// URL only extension
export {};
declare global {
    interface URL {
        replace(find: string, replace: string): string;
    }
}

if (!URL.prototype.replace) {
    URL.prototype.replace = function replace(
        this: URL,
        find: string,
        replace: string
    ): string {
        return this.toString().replace(find, replace);
    };
}

export {};
declare global {
    interface URL {
        sameBase(base: URL | Location): boolean;
    }
}

if (!URL.prototype.sameBase) {
    URL.prototype.sameBase = function sameBase(
        this: URL,
        target: URL
    ): boolean {
        return this.host === target.host && this.port === target.port;
    };
}

export {};
declare global {
    interface URL {
        makeBase(base: URL | Location): string;
    }
}

if (!URL.prototype.makeBase) {
    URL.prototype.makeBase = function makeBase(this: URL, base: URL): string {
        return this.replace(`${base.protocol}//${base.host}`, ".");
    };
}

export {};
declare global {
    interface URL {
        removeBase(): string;
    }
}

if (!URL.prototype.removeBase) {
    URL.prototype.removeBase = function removeBase(this: URL): string {
        return this.pathname.substring(1);
    };
}

export {};
declare global {
    interface URL {
        clean(): URL;
    }
}

if (!URL.prototype.clean) {
    URL.prototype.clean = function clean(this: URL): URL {
        return new URL(
            `${this.protocol}//${this.host}` +
                this.pathname.replace(/\/\//g, "/")
        );
    };
}
